// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-cf608aaa] :not(.subscribe-form *){font-weight:300;color:#000}.footer[data-v-cf608aaa] .footer__logo{font-weight:400}.footer[data-v-cf608aaa] a{transition:.15s}.footer[data-v-cf608aaa] a:hover,.footer[data-v-cf608aaa] a:hover *{color:#928656}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
